import { DAY_PARTS, DAY_PARTS_IN_ORDER } from '../constants';
import { DayPartTypes } from '../types';

import capitalize from 'lodash/capitalize';

export const DAY_PARTS_TO_SHOW = {
  [DAY_PARTS.MORNING]: 'утро',
  [DAY_PARTS.DAY]: 'день',
  [DAY_PARTS.EVENING]: 'вечер',
  [DAY_PARTS.NIGHT]: 'ночь',
};

const combineDayParts = (dayPartAvailability: Record<DayPartTypes, boolean>): string | null => {
  if (!dayPartAvailability) {
    return null;
  }

  if (
    Object.values(DAY_PARTS).every((dayPart) => {
      return dayPartAvailability[dayPart];
    })
  ) {
    return 'Круглосуточно';
  }

  const dayPartsToShow = (Object.keys(dayPartAvailability) as DayPartTypes[])
    .filter((dayPart) => dayPartAvailability[dayPart])
    .sort((a, b) => {
      return DAY_PARTS_IN_ORDER.indexOf(a) - DAY_PARTS_IN_ORDER.indexOf(b);
    });

  return dayPartsToShow.reduce((acc, dayPart, index) => {
    if (index === 0) {
      return `${capitalize(DAY_PARTS_TO_SHOW[dayPart])}`;
    }

    return `${acc}, ${DAY_PARTS_TO_SHOW[dayPart]}`;
  }, '');
};

export default combineDayParts;
